import { Injectable } from '@nestjs/common';
import { CommonResponseModel } from '@project-management-system/shared-models';
import * as nodemailer from 'nodemailer';
import { ErrorResponse } from 'packages/libs/backend-utils/src/models/global-res-object';
import { SendOptions } from './dtos/send-mail.dto';


@Injectable()
export class GSuiteMailerService {
  private transporter: nodemailer.Transporter;

  constructor() {
    this.transporter = nodemailer.createTransport({
      service: 'gmail',
      host: 'smtp.gmail.com',
      port: 587,
      secure: false,
      auth: {
        user: 'sourcing2.unit12@shahi.co.in',
        pass: 'bunj scte zcur hcrz',
      },
    });
  }

  async sendGSuiteMail(req: SendOptions, maxRetries: number = 3) {
    let retries = 0;
    while (retries < maxRetries) {
      try {
        if (!Array.isArray(req.to)) {
          if (['merchant@shahi.com', 'mh@shahi.com', 'csp@shahi.com', 'se@shahi.com', 'sh@shahi.com', 'se1@shahi.com', 'se2@shahi.com'].includes(req.to)) {
            req.to = ['prashanth.jaganath@shahi.co.in','bhanuteja.reddi@schemaxtech.com']
          }
        } else {
          for (const rec of req.to) {
            if (['merchant@shahi.com', 'mh@shahi.com', 'csp@shahi.com', 'se@shahi.com', 'sh@shahi.com', 'se1@shahi.com', 'se2@shahi.com'].includes(rec)) {
              req.to = ['prashanth.jaganath@shahi.co.in','bhanuteja.reddi@schemaxtech.com']
              break;
            }
          }
        }
        await this.transporter.sendMail(req);
        return new CommonResponseModel(true, 1111, 'Mail sent successfully');
      } catch (error) {
        console.error('Error sending email:', error);
        if (
          error.code === 'EENVELOPE' ||
          error.code === 'ECONNECTION' ||
          error.code === 'EMESSAGE'
        ) {
          throw new ErrorResponse(
            500,
            'Failed to send mail: Invalid email configuration'
          );
        } else if (error.code === 'EPROTOCOL' || error.code === 'EAUTH') {
          throw new ErrorResponse(
            500,
            'Failed to send mail: Authentication or protocol error'
          );
        } else {
          console.error(`Error sending email. Retrying...`);
          retries++;
          const delay = Math.pow(2, retries - 1) * 1000; // Exponential backoff
          await new Promise(resolve => setTimeout(resolve, delay));
        }
      }
    }

    throw new ErrorResponse(
      500,
      'Failed to send mail: Unknown error'
    );
  }


}
